import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { initialLedgerFilter } from '../../Data/Constants'
import { setLedgerFilter } from '../../Redux/slices/partyState'


import GetTimeStamp from '../../Utils/GetTimeStamp'
import handleChange from '../../Utils/HandleChange'
import { FormInput } from '../Controls/Input'


export default function LedgerFilterBar() {
    const FilterFormRef = useRef()
    const [filters, setFilters] = useState(initialLedgerFilter)
    const dispatch = useDispatch()
    const changeHandler = handleChange(filters,setFilters)
    const submitHandler = (e)=>{
        e.preventDefault()
        const FormattedFilter = {
            ...filters,
            date_from:filters.date_from&&GetTimeStamp(filters.date_from),
            date_to:filters.date_to&&GetTimeStamp(filters.date_to)
        }

        dispatch(setLedgerFilter(FormattedFilter))
    }
    const ResetFilter = (e)=>{
        e.preventDefault()
        setFilters(initialLedgerFilter)
        dispatch(setLedgerFilter(initialLedgerFilter))
        FilterFormRef.current.reset()
    }
    return (
        <form ref={FilterFormRef} className='px-8 pb-3 bg-gray-100 flex flex-wrap justify-between items-start rounded-lg shadow-md border pt-6'>
            <div className='w-full lg:w-1/2 flex flex-wrap justify-between items-center'>
                <FormInput name='date_from' type='date' label='From'  onChange={changeHandler}/>
                <FormInput name='date_to' type='date' label='To' onChange={changeHandler} />
            </div>
            <div className='w-full lg:w-1/2 flex flex-wrap items-center pt-9'>
                
                <button onClick={submitHandler} className='p-3 mb-5 bg-blue-500 rounded-md text-white font-medium mx-4'>Filter Result</button>
                <button onClick={ResetFilter} className='p-3 mb-5 bg-gray-500 rounded-md text-white font-medium ml-4'>Reset all</button>
            </div>

        </form>
    )
}
